
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';

@Component({
    name: 'AppSidebar',
})
export default class AppSidebar extends Vue {
    @Prop({ default: false }) private loading!: boolean;
    @Prop({ default: false, required: false }) private isStatistics!: boolean;

    private collapsed: boolean = false;
    private width: number = this.isStatistics ? 500 : 400;
    private sidebarOffset: number = 0;
    private triggerTop: number = 55;
    private isTriggerTopInitialized: boolean = false;

    private get sidebarRef() {
        return (this.$refs.appSidebar as any) ?? null;
    }

    private get layoutSidebarRef() {
        return ((this.$refs.layoutSidebar as Vue) ?? null)?.$el as HTMLElement | null;
    }
    private get backdropHeight() {
        return `calc(100vh - ${this.sidebarOffset}px)`;
    }

    // Calculate app sidebar height dynamically
    private mounted() {
        window.addEventListener('resize', this.calculateSidebarOffsetTop);
        // Use double requestAnimationFrame to ensure DOM has fully painted before calculating
        this.$nextTick(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.calculateSidebarOffsetTop();
                });
            });
        });
    }

    private beforeDestroy() {
        window.removeEventListener('resize', this.calculateSidebarOffsetTop);
    }

    private calculateSidebarOffsetTop() {
        if (!this.sidebarRef || !this.layoutSidebarRef) {
            return;
        }

        this.sidebarOffset = this.sidebarRef.offsetTop;

        if (!this.isTriggerTopInitialized) {
            this.$nextTick(() => {
                if (!this.layoutSidebarRef) {
                    return;
                }

                this.triggerTop =
                    this.layoutSidebarRef.getBoundingClientRect().top + (window.innerWidth <= 600 ? 115 : 55);
                this.isTriggerTopInitialized = true;
            });
        }
    }

    get showBackdrop() {
        return !this.collapsed;
    }

    @Watch('collapsed', { immediate: true })
    private projectSidebarCollapsed() {
        if (!this.collapsed) {
            this.$nextTick(() => this.calculateSidebarOffsetTop());
        }

        if (!this.isStatistics) {
            this.$store.dispatch('generic/updateSidebarState', this.collapsed);
        }
    }
}
